<template>
  <v-dialog
    :value="dialogModel"
    max-width="1100"
    eager
    content-class="cash-opening-dialog"
    overlay-opacity="0.46"
    @input="dialogModel = $event"
  >
    <v-card>
      <v-card-title class="d-flex justify-space-between align-center">
        <span>Caja chica y registros</span>
        <v-btn icon @click="$emit('input', false)">
          <v-icon>mdi-close</v-icon>
        </v-btn>
      </v-card-title>

      <v-card-text>
        <v-alert v-if="errorMessage" type="error" dense outlined>
          {{ errorMessage }}
        </v-alert>

        <v-alert v-if="successMessage" type="success" dense outlined>
          {{ successMessage }}
        </v-alert>

        <v-row class="mb-2 mt-2">
          <v-col cols="12" md="4">
          </v-col>
          <v-col cols="12" md="8" class="d-flex justify-md-end">
            <v-btn color="primary" small :loading="loading" @click="refreshData">
              <v-icon left small>mdi-reload</v-icon>
              Recargar
            </v-btn>
          </v-col>
        </v-row>

        <v-tabs v-model="tab" background-color="primary" dark>
          <v-tab href="#tab-1">Caja Chica</v-tab>
          <v-tab href="#tab-2">Registros</v-tab>
        </v-tabs>

        <v-tabs-items v-model="tab">
          <v-tab-item value="tab-1">
            <v-card flat class="pa-2">
              <v-card outlined class="pa-3 cash-control-form-section">
                <v-row dense>
                  <v-col cols="12">
                    <div class="cash-control-form-title mb-2">Datos del movimiento</div>
                  </v-col>
                  <v-col cols="12" md="3" class="pb-1">
                    <v-select
                      v-model="controlForm.MovementType"
                      :items="movementTypes"
                      item-text="text"
                      item-value="value"
                      outlined
                      dense
                      label="Tipo de movimiento"
                    ></v-select>
                  </v-col>
                  <v-col cols="12" md="3" class="pb-1">
                    <v-text-field
                      v-model="controlForm.Amount"
                      type="number"
                      min="0"
                      step="0.01"
                      outlined
                      dense
                      label="Monto"
                    ></v-text-field>
                  </v-col>
                  <v-col cols="12" md="6" class="pb-1">
                    <v-text-field
                      v-model="controlForm.Detail"
                      outlined
                      dense
                      label="Detalle"
                    ></v-text-field>
                  </v-col>
                </v-row>

                <div class="cash-control-form-divider my-2"></div>

                <v-row dense>
                  <v-col cols="12">
                    <div class="cash-control-form-title mb-2">Responsables</div>
                  </v-col>
                  <v-col cols="12" md="6" class="pb-1">
                    <v-select
                      v-model="controlForm.InternalResponsibleUserId"
                      :items="internalUsers"
                      item-text="FullName"
                      item-value="ID_User"
                      outlined
                      dense
                      label="Persona interna responsable"
                    ></v-select>
                  </v-col>
                  <v-col cols="12" md="6" class="pb-1">
                    <v-text-field
                      v-model="controlForm.ExternalResponsible"
                      outlined
                      dense
                      label="Persona externa responsable"
                    ></v-text-field>
                  </v-col>
                  <v-col cols="12" class="d-flex justify-end pt-1 pb-0">
                    <v-btn color="primary" :loading="loading" @click="createControl">
                      Guardar movimiento
                    </v-btn>
                  </v-col>
                </v-row>
              </v-card>
            </v-card>
          </v-tab-item>

          <v-tab-item value="tab-2">
            <v-card flat class="pa-4">
              <h3 class="mb-3">Movimientos</h3>
              <v-data-table
                :headers="controlHeaders"
                :items="controls"
                dense
                :items-per-page="8"
              >
                <template v-slot:[`item.MovementType`]="{ item }">
                  {{ item.MovementType == 1 ? 'Egreso' : 'Ingreso' }}
                </template>
                <template v-slot:[`item.Amount`]="{ item }">
                  {{ formatAmount(item.Amount) }}
                </template>
                <template v-slot:[`item.InternalResponsibleUserId`]="{ item }">
                  {{ getInternalUserName(item.InternalResponsibleUserId) }}
                </template>
                <template v-slot:[`item.CreatedAt`]="{ item }">
                  {{ formatDate(item.CreatedAt) }}
                </template>
                <template v-slot:[`item.actions`]="{ item }">
                  <v-btn small icon color="primary" title="Imprimir comprobante" @click="printControlRecord(item)">
                    <v-icon small>mdi-printer</v-icon>
                  </v-btn>
                </template>
              </v-data-table>
            </v-card>
          </v-tab-item>
        </v-tabs-items>
      </v-card-text>
    </v-card>
  </v-dialog>
</template>

<script>
function getStoredUser() {
  try {
    return JSON.parse(localStorage.getItem("user")) || {};
  } catch (error) {
    return {};
  }
}

export default {
  name: "CashControlModal",
  props: {
    value: {
      type: Boolean,
      default: false,
    },
    status: {
      type: Object,
      default: () => ({}),
    },
    targetOpeningId: {
      type: [Number, String],
      default: null,
    },
    openingOverride: {
      type: Object,
      default: null,
    },
  },
  data() {
    return {
      tab: "tab-1",
      loading: false,
      storedUser: getStoredUser(),
      controls: [],
      internalUsers: [],
      controlForm: {
        MovementType: 2,
        Detail: "",
        Amount: null,
        ExternalResponsible: "",
        InternalResponsibleUserId: null,
      },
      errorMessage: "",
      successMessage: "",
      movementTypes: [
        { text: "Egreso", value: 1 },
        { text: "Ingreso", value: 2 },
      ],
      controlHeaders: [
        { text: "ID", value: "ID_CashControl" },
        { text: "Tipo", value: "MovementType" },
        { text: "Detalle", value: "Detail" },
        { text: "Monto", value: "Amount" },
        { text: "Responsable externo", value: "ExternalResponsible" },
        { text: "Responsable interno", value: "InternalResponsibleUserId" },
        { text: "Fecha", value: "CreatedAt" },
        { text: "Imprimir", value: "actions", sortable: false, align: "center" },
      ],
    };
  },
  computed: {
    dialogModel: {
      get() {
        return this.value;
      },
      set(value) {
        this.$emit("input", value);
      },
    },
    activeOpeningData() {
      return this.openingOverride || this.status?.activeOpening || null;
    },
    hasActiveOpening() {
      return Boolean(this.activeOpeningData);
    },
    activeOpeningId() {
      return this.activeOpeningData?.ID_CashOpening
        || this.activeOpeningData?.openingId
        || this.targetOpeningId
        || null;
    },
    currentPointSale() {
      return this.activeOpeningData?.PointSale
        || this.activeOpeningData?.pointSale
        || this.status?.pointSale
        || null;
    },
  },
  watch: {
    value: {
      immediate: true,
      handler(newValue) {
        if (newValue) {
          this.refreshData();
        }
      },
    },
  },
  methods: {
    clearMessages() {
      this.errorMessage = "";
      this.successMessage = "";
    },
    async refreshData() {
      this.clearMessages();
      this.loading = true;
      try {
        const [controlsResponse, usersResponse] = await Promise.all([
          this.$API.cashOpening.getControls({
            openingId: this.activeOpeningId || undefined,
          }),
          this.$API.cashOpening.getInternalUsers(),
        ]);

        this.controls = controlsResponse?.data || [];
        this.internalUsers = usersResponse?.data || [];
      } catch (error) {
        this.errorMessage = error?.response?.data?.message || error?.message || "No se pudieron cargar los registros de caja";
      } finally {
        this.loading = false;
      }
    },
    async createControl() {
      this.clearMessages();
      this.loading = true;
      try {
        const response = await this.$API.cashOpening.createControl({
          ...this.controlForm,
          OpeningId: this.activeOpeningId || undefined,
        });
        this.successMessage = response?.message || "Movimiento registrado correctamente";
        await this.generateControlReceiptPdf(response?.data);
        this.controlForm = {
          MovementType: 2,
          Detail: "",
          Amount: null,
          ExternalResponsible: "",
          InternalResponsibleUserId: null,
        };
        await this.refreshData();
        this.$emit("status-updated");
      } catch (error) {
        this.errorMessage = error?.response?.data?.message || error?.message || "No se pudo registrar el movimiento";
      } finally {
        this.loading = false;
      }
    },
    async printControlRecord(controlRecord) {
      try {
        await this.generateControlReceiptPdf(controlRecord);
      } catch (error) {
        this.errorMessage = error?.message || "No se pudo generar el comprobante";
      }
    },
    async generateControlReceiptPdf(controlRecord) {
      if (!controlRecord) {
        return;
      }

      const { jsPDF } = await import("jspdf");
      const doc = new jsPDF({
        unit: "mm",
        format: "letter",
      });

      const copyLabels = ["Original", "Copia 1", "Copia 2"];
      const movementTypeText = Number(controlRecord.MovementType) === 1 ? "Egreso" : "Ingreso";
      const internalResponsible = this.getInternalUserName(controlRecord.InternalResponsibleUserId) || "-";
      const pointSale = this.currentPointSale || this.storedUser.pointsale || "-";
      const amount = this.formatAmount(controlRecord.Amount);
      const createdAt = this.formatDate(controlRecord.CreatedAt || new Date());
      const approvedByName = this.getUserDisplayName(controlRecord.ID_User) || "-";
      const openingId = controlRecord.ID_CashOpening || "-";
      const payee = internalResponsible !== "-" ? internalResponsible : (controlRecord.ExternalResponsible || "-");

      const borderColor = [45, 48, 54];
      const copyHeight = 68;
      const copyGap = 22;
      const baseX = 8;
      const baseY = 10;
      const totalWidth = 200;

      const drawLineField = (label, value, x, y, lineWidth) => {
        doc.setFont("helvetica", "normal");
        doc.setFontSize(8.5);
        doc.setTextColor(35, 35, 35);
        doc.text(`${label}:`, x, y);
        doc.line(x + 22, y + 1, x + lineWidth, y + 1);
        if (value) {
          const text = doc.splitTextToSize(String(value), lineWidth - 26);
          doc.text(text[0], x + 24, y);
        }
      };

      copyLabels.forEach((copyLabel, index) => {
        const top = baseY + (index * (copyHeight + copyGap));

        doc.setDrawColor(...borderColor);
        doc.setLineWidth(0.5);
        doc.roundedRect(baseX, top, totalWidth, copyHeight, 4, 4);

        doc.setFont("helvetica", "bold");
        doc.setTextColor(0, 0, 0);
        doc.setFontSize(16);
        doc.text("VALE DE CAJA CHICA", baseX + 6, top + 8);
        doc.setFontSize(9.5);
        doc.text(`FECHA: ${createdAt}`, baseX + 6, top + 16);

        doc.roundedRect(baseX + 150, top + 1.5, 44, 10, 2, 2);
        doc.setFontSize(12);
        doc.text("$", baseX + 153, top + 8.5);
        doc.text(`${amount}`, baseX + 190, top + 8.5, { align: "right" });
        doc.setFontSize(8);
        doc.text(copyLabel.toUpperCase(), baseX + 172, top + 15.5, { align: "center" });

        doc.setFont("helvetica", "bold");
        doc.setFontSize(10.5);
        doc.text(movementTypeText.toUpperCase(), baseX + 6, top + 24);

        drawLineField("Paguese a", payee, baseX + 6, top + 32, 186);
        drawLineField("Por concepto de", controlRecord.Detail || "-", baseX + 6, top + 42, 186);
        drawLineField("", "", baseX + 6, top + 52, 186);

        doc.line(baseX + 2, top + 58, baseX + 198, top + 58);
        doc.line(baseX + 34, top + 58, baseX + 34, top + 68);

        doc.setFont("helvetica", "bold");
        doc.setFontSize(7.2);
        doc.text("CUENTA No.", baseX + 4, top + 62);
        doc.text("APROBADO POR", baseX + 47, top + 62);

        doc.setFont("helvetica", "normal");
        doc.setFontSize(7.8);
        doc.text(`${openingId}`, baseX + 4, top + 67);
        doc.text(`${approvedByName}  |  PV ${pointSale}`, baseX + 47, top + 67);

        const signatureTop = top + copyHeight + 10;
        doc.line(baseX + 16, signatureTop, baseX + 82, signatureTop);
        doc.line(baseX + 126, signatureTop, baseX + 192, signatureTop);
        doc.setFont("helvetica", "bold");
        doc.setFontSize(8);
        doc.text("ENTREGA", baseX + 49, signatureTop + 4.5, { align: "center" });
        doc.text("RECIBE", baseX + 159, signatureTop + 4.5, { align: "center" });

        if (index < copyLabels.length - 1) {
          const cutLineY = top + copyHeight + copyGap - 4;
          doc.setDrawColor(120, 120, 120);
          doc.setLineWidth(0.2);
          doc.setLineDashPattern([1.5, 1.5], 0);
          doc.line(baseX, cutLineY, baseX + totalWidth, cutLineY);
          doc.setLineDashPattern([], 0);
          doc.setDrawColor(...borderColor);
        }
      });

      const pdfBlob = doc.output("blob");
      const pdfUrl = URL.createObjectURL(pdfBlob);
      window.open(pdfUrl, "_blank");
      setTimeout(() => URL.revokeObjectURL(pdfUrl), 60000);
    },
    formatDate(value) {
      if (!value) return "";
      return new Date(value).toLocaleString();
    },
    formatAmount(value) {
      const amount = Number(value || 0);
      return amount.toLocaleString(undefined, {
        minimumFractionDigits: 2,
        maximumFractionDigits: 2,
      });
    },
    getInternalUserName(userId) {
      if (!userId) return "";
      const found = this.internalUsers.find((item) => item.ID_User === userId);
      return found?.FullName || userId;
    },
    getUserDisplayName(userId) {
      if (!userId) {
        const fullName = `${this.storedUser.firstName || ""} ${this.storedUser.lastName || ""}`.trim();
        return fullName || this.storedUser.username || this.storedUser.ID_User || "";
      }

      const found = this.internalUsers.find((item) => item.ID_User === userId);
      if (found?.FullName) {
        return found.FullName;
      }

      if (String(userId) === String(this.storedUser.id || this.storedUser.ID_User || "")) {
        const fullName = `${this.storedUser.firstName || ""} ${this.storedUser.lastName || ""}`.trim();
        return fullName || this.storedUser.username || userId;
      }

      return userId;
    },
  },
};
</script>

<style>
.cash-opening-dialog {
  z-index: 3000 !important;
}

.cash-control-form-section {
  border-radius: 12px;
  background: #fbfdff;
}

.cash-control-form-divider {
  border-top: 1px solid #d9e4ef;
}

.cash-control-form-title {
  font-size: 16px;
  font-weight: 700;
  color: #2f3640;
}
</style>
